import React from 'react';

export const CheckIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
      <path d="M4.49996902,7.52015332 L2.73712636,5.59724454 C2.36391367,5.19014414 1.73134493,5.16267272 1.32424453,5.53588541 C0.91714413,5.9090981 0.889672711,6.54166684 1.2628854,6.94876724 L3.7628854,9.67576724 C4.15923011,10.1081 4.84083684,10.1080831 5.23716002,9.67573052 L10.73716,3.67573052 C11.1103524,3.26861153 11.0828495,2.63604416 10.6757305,2.26285175 C10.2686115,1.88965934 9.63604414,1.91716227 9.26285174,2.32428126 L4.49996902,7.52015332 Z" />
    </svg>
  );
};
